import React from "react";
import { Clock } from "lucide-react";
import Card from "./Card";
import { displayValue } from "./utils";
import textTranslator from "../../../../utils/useTextTranslator";
import Txt from "../../../Text";

const Text = ({ children, className, page = "APPOINTMENTS" }) => {
	return (
		<Txt page={page} className={className} keyName={page}>
			{children}
		</Txt>
	);
};

const AppointmentTimestampCard = ({ appointment, formatDate, darkMode, arClass }) => {
	const creatorName = appointment?.creator
		? `${appointment?.creator?.firstName || ""} ${appointment?.creator?.lastName || ""}`.trim() || "-"
		: "-";
	const creatorRole = appointment?.creator?.role
		? textTranslator(appointment.creator.role, "ROLES") || appointment.creator.role
		: "-";

	return (
		<Card
			title={textTranslator("Timeline", "APPOINTMENTS")}
			subtitle={textTranslator("Created and updated information", "APPOINTMENTS")}
			icon={Clock}
			darkMode={darkMode}
			arClass={arClass}
		>
			<div className="space-y-4">
				{appointment?.createdAt && (
					<div className="flex items-center justify-between p-3 rounded-lg" style={{
						background: darkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)"
					}}>
						<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
							<Text>Created At</Text>
						</span>
						<span className={darkMode ? "text-white font-semibold" : "text-slate-900 font-semibold"}>
							{formatDate(appointment.createdAt, true)}
						</span>
					</div>
				)}

				{appointment?.updatedAt && (
					<div className="flex items-center justify-between p-3 rounded-lg" style={{
						background: darkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)"
					}}>
						<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
							<Text>Updated At</Text>
						</span>
						<span className={darkMode ? "text-white font-semibold" : "text-slate-900 font-semibold"}>
							{formatDate(appointment.updatedAt, true)}
						</span>
					</div>
				)}

				{appointment?.creator && (
					<div className="flex items-center justify-between p-3 rounded-lg" style={{
						background: darkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)"
					}}>
						<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
							<Text>Created By</Text>
						</span>
						<div className="text-right">
							<div className={darkMode ? "text-white font-semibold" : "text-slate-900 font-semibold"}>
								{displayValue(creatorName)}
							</div>
							<div className={darkMode ? "text-xs text-gray-400" : "text-xs text-slate-500"}>
								{displayValue(creatorRole)}
							</div>
						</div>
					</div>
				)}
			</div>
		</Card>
	);
};

export default AppointmentTimestampCard;
